module.exports = __webpack_public_path__ + "static/a-xx-179-art-75e7722c5b82cda7ad5b3afbe822484c.jpg";